/* eslint-disable max-len, no-trailing-spaces, eol-last, indent, comma-dangle, comma-spacing, prefer-const, spaced-comment, key-spacing, no-multi-spaces, semi, object-property-newline, quotes, react/display-name, id-length, operator-linebreak, react/prop-types, no-shadow, no-undef, max-lines-per-function, space-infix-ops, no-unused-vars, init-declarations */
import { serviceName } from '../resources/serviceConstants';
import {
  DEAL_PARAMETERS_MASTER,
  DEAL_PARAMETERS_SLA,
  DEAL_PARAMETERS_WORKFLOW,
} from '../resources/endPoint';

export const parametersList = () => {
  return {
    url: DEAL_PARAMETERS_MASTER,
    method: 'get',
    headers: { 'content-type': 'application/json'},
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
  };
};

export const enableOrDisabledealSla = (data, parameterId) => {
  const url = `${DEAL_PARAMETERS_SLA}?parameter_id=${parameterId}` ;
  return {
    url: url,
    method: 'put',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.MASTER_MS,
  };
};

export const enableOrDisabledealWorkflow = (data, parameterId) => {
  const url = `${DEAL_PARAMETERS_WORKFLOW}?parameter_id=${parameterId}` ;
    return {
      url: url,
      method: 'put',
      headers: { 'content-type': 'application/json' },
      authRequired: false,
      csrfToken: true,
      payload: data,
      service: serviceName.MASTER_MS,
    };
  };
